import { CommonResponse, CommonResponseList } from "src/model/common";
import { VesselDetail, Vessels } from "src/model/vessels";
import { getRequest } from "src/services/api/http";
import { URL_ENDPOINT } from "src/utils/constants/service";

function getVessels(params: Record<string, any>) {
  const url = URL_ENDPOINT.vessels
  return getRequest(url, params, new Vessels()) as Promise<Vessels>
}

function getSummaryVessels() {
  const url = URL_ENDPOINT.vessels + '/summary'
  return getRequest(url, {}) as Promise<CommonResponse>
}

function getVesselDetail(mmsi: string) {
  const url = URL_ENDPOINT.vessels + `/${mmsi}`
  return getRequest(url, {}, new VesselDetail()) as Promise<VesselDetail>
}

function getVesselDetailRecentSpeed(params: Record<string, any>) {
  const url = URL_ENDPOINT.vessels + `/ship-movement`
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<{
    Date?: string,
    sog?: number
  }>>
}

function getVesselDetailRecentDraught(params: Record<string, any>) {
  const url = URL_ENDPOINT.vessels + `/ship-portcalls`
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<{
    Date?: string,
    throughput?: number
  }>>
}

export const VesselsService = {
  getVessels,
  getSummaryVessels,
  getVesselDetail,
  getVesselDetailRecentSpeed,
  getVesselDetailRecentDraught
}